
import {
  VDR_GROUPS_REQUEST,
  VDR_GROUPS_SUCCESS,
  VDR_GROUPS_FAIL,
  VDR_COMPANY_REQUEST,
  VDR_COMPANY_SUCCESS,
  VDR_COMPANY_FAIL,
  VDR_LEVEL_REQUEST,
  VDR_LEVEL_SUCCESS,
  VDR_LEVEL_FAIL,
  VDR_HOME_REQUEST,
  VDR_HOME_SUCCESS,
  VDR_HOME_FAIL,
  VDR_UPLOAD_IMAGE_REQUEST,
  VDR_UPLOAD_IMAGE_SUCCESS,
  VDR_UPLOAD_IMAGE_FAIL,
  PUBLIC_IP_REQUEST,
  PUBLIC_IP_SUCCESS,
  PUBLIC_IP_FAIL,
  VDR_SINGLE_COMPANY_REQUEST,
  VDR_SINGLE_COMPANY_SUCCESS,
  VDR_SINGLE_COMPANY_FAIL,
  PDF_LINK_REQUEST,
  PDF_LINK_SUCCESS,
  MEDIA_MODEL_REQUEST,
  MEDIA_MODEL_OPEN,
  MEDIA_MODEL_CLOSE,
  MEDIA_DATA_REQUEST,
  MEDIA_DATA_SUCCESS,
  MEDIA_DATA_FAIL,
  DATA_20_YEARS_REQUEST,
  DATA_20_YEARS_SUCCESS,
  DATA_20_YEARS_FAIL,
  DATA_20_YEARS_QUARTERLY_REQUEST,
  DATA_20_YEARS_QUARTERLY_SUCCESS,
  DATA_20_YEARS_QUARTERLY_FAIL,
  PEER_TO_PEER_REQUEST,
  PEER_TO_PEER_SUCCESS,
  PEER_TO_PEER_FAIL,

  SORT_DATA_REQUEST,
  SORT_DATA_SUCCESS,
  SORT_DATA_FAIL,
  SORT_DATA_UPDATE_REQUEST,
  SORT_DATA_UPDATE_SUCCESS,
  SORT_DATA_UPDATE_FAIL,
  VDR_HOME_SUCCESS_FILTER,
  FAVORITE_REQUEST,
  FAVORITE_SUCCESS,
  FAVORITE_FAIL,
  EMPLOYEE_REQUEST,
  EMPLOYEE_SUCCESS,
  EMPLOYEE_FAIL,
  SEGMENT_REQUEST,
  SEGMENT_SUCCESS,
  SEGMENT_FAIL,
  SEGMENT_ASSIGN_REQUEST,
  SEGMENT_ASSIGN_SUCCESS,
  SEGMENT_ASSIGN_FAIL,
  QUARTERLY_REVIEW_REQUEST,
  QUARTERLY_REVIEW_RESET,
  QUARTERLY_REVIEW_SUCCESS,
  QUARTERLY_REVIEW_FAIL,
  QUARTERLY_SEGMENT_REQUEST,
  QUARTERLY_SEGMENT_SUCCESS,
  QUARTERLY_SEGMENT_RESET,
  QUARTERLY_SEGMENT_FAIL,
  VDR_HOME_COMPANIES_REQUEST,
VDR_HOME_COMPANIES_SUCCESS,
VDR_HOME_COMPANIES_SUCCESS_FILTER,
VDR_HOME_COMPANIES_FAIL,
} from './../../constants/VdrConstants';

import publicIp from 'public-ip';


import { createReducer } from "@reduxjs/toolkit"


export const FavoriteCompanyReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  FavoriteCompanyReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  FavoriteCompanyRequest: (state) => {
    state.loading = true;
  },
  FavoriteCompanySuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  FavoriteCompanyFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});

export const dateAPIReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  dateAPIReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  dateAPIRequest: (state) => {
    state.loading = true;
  },
  dateAPISuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  dateAPIFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});



export const PriceActionFilterReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  PriceActionFilterReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  PriceActionFilterRequest: (state) => {
    state.loading = true;
  },
  PriceActionFilterSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  PriceActionFilterFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});

export const priceIndexMasterReducer = createReducer({
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  PriceIndexReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  PriceIndexRequest: (state) => {
    state.loading = true;
  },
  PriceIndexSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  PriceIndexFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});

export const PriceActionReducer = createReducer({
  firstLoading: true,
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  PriceActionReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  PriceActionRequest: (state) => {
    state.loading = true;
  },
  PriceActionSuccess: (state, action) => {
    state.loading = false;
    state.firstLoading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  PriceActionFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});



export const ForensicReducer = createReducer({
  firstLoading: true,
  loading: true,
  data: [],
  msg: null,
  error: null,
}, {
  ForensicReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
  },
  ForensicRequest: (state) => {
    state.loading = true;
  },
  ForensicSuccess: (state, action) => {
    state.loading = false;
    state.firstLoading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
  },
  ForensicFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
  },
});



export const MessageReducer = createReducer({
  message: {},
},
{
  MessageRequest: (state, action) => {
    state.message = action.payload
  }
});

export const GetOmakaraUsersReducer = createReducer({
  loadingUsers: true,
  data: [],
},
{
  getOmakaraUsers: (state, action) => {
    state.data = action.payload;
    state.loadingUsers = false;
  }
});



export const filesLogReducer = createReducer({
  loading: true,
  loadingOnAdd: true,
  data: [],
  msg: null,
  error: null,
}, {
  FilesLogReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  FilesLogRequest: (state) => {
    state.loading = true;
    state.loadingOnAdd = false;
  },
  FilesLogAdd: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  FilesLogSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  FilesLogFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
});


export const AssignEmployeeReducer = createReducer({
  loading: true,
  loadingOnAdd: true,
  data: [],
  msg: null,
  error: null,
}, {
  AssignEmployeeReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  AssignEmployeeRequest: (state) => {
    state.loading = true;
    state.loadingOnAdd = false;
  },
  AssignEmployeeAdd: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  AssignEmployeeSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  AssignEmployeeFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
});



export const vdrMediaGroupReducer = createReducer({
  loading: true,
  loadingOnAdd: true,
  data: [],
  msg: null,
  error: null,
}, {
  vdrMediaGroupReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaGroupRequest: (state) => {
    state.loading = true;
    state.loadingOnAdd = false;
  },
  vdrMediaGroupAdd: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaGroupSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaGroupFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
});



export const vdrMediaReducer = createReducer({
  loading: true,
  loadingOnAdd: true,
  data: [],
  msg: null,
  error: null,
}, {
  vdrMediaReset: (state) => {
    state.loading = false;
    state.data = null;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaRequest: (state) => {
    state.loading = true;
    state.loadingOnAdd = false;
  },
  vdrMediaAdd: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaSuccess: (state, action) => {
    state.loading = false;
    state.data = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
  vdrMediaFailure: (state, action) => {
    state.loading = true;
    state.data_error = action.payload;
    state.msg = null;
    state.error = null;
    state.loadingOnAdd = false;
  },
});



export const vdrLevelReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_LEVEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VDR_LEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_LEVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};




export const vdrGroupsReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VDR_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_GROUPS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const vdrCompanyReducer = (state = { loading: true, loadingAdd: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        loadingAdd: true,
      };
    case VDR_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingAdd: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        loadingAdd: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const vdrEmployeeReducer = (state = { loading: true, loadingAdd: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        loadingAdd: true,
      };
    case EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingAdd: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.data.length,
      };
    case EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        loadingAdd: false,
        error: action.payload,
      };
    default:
      return state;
  }
};



export const vdrHomeCompaniesReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_HOME_COMPANIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VDR_HOME_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_HOME_COMPANIES_SUCCESS_FILTER:
      return {
        ...state,
        loading: false,
        filterData: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_HOME_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};




export const vdrHomeReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VDR_HOME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_HOME_SUCCESS_FILTER:
      return {
        ...state,
        loading: false,
        filterData: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_HOME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrSingleCompanyReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_SINGLE_COMPANY_REQUEST:
      return {
        ...state,
        data: [],
        loading: true,
      };
    case VDR_SINGLE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        // totalRows: action.payload?.Data.length,
      };
    case VDR_SINGLE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const vdrUploadImageReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case VDR_UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VDR_UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
        totalRows: action.payload?.Data.length,
      };
    case VDR_UPLOAD_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const vdrPDFLinkReducer = (state = { loading: true, data: null, totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case PDF_LINK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PDF_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    default:
      return state;
  }
};


export const ipAddressReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case PUBLIC_IP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PUBLIC_IP_SUCCESS:
      localStorage.setItem('ipData', JSON.stringify(action.payload))
      return {
        ...state,
        loading: false,
        data: action.payload,
        msg: action.payload.msg,
      };
    case PUBLIC_IP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrMediaDataReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case MEDIA_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MEDIA_DATA_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case MEDIA_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrData20YearsReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case DATA_20_YEARS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DATA_20_YEARS_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case DATA_20_YEARS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrPeerToPeerReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case PEER_TO_PEER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PEER_TO_PEER_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case PEER_TO_PEER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrFavoriteReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case FAVORITE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAVORITE_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case FAVORITE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrSortDataReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case SORT_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SORT_DATA_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        // totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case SORT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrSortUpdateDataReducer = (state = { loading: true, data: [], msg: null, error: null }, action) => {
  switch (action.type) {
    case SORT_DATA_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SORT_DATA_UPDATE_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        // totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case SORT_DATA_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const vdrData20YearsQuarterlyReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case DATA_20_YEARS_QUARTERLY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DATA_20_YEARS_QUARTERLY_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case DATA_20_YEARS_QUARTERLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const SegmentReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case SEGMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEGMENT_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case SEGMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const SegmentAssignReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case SEGMENT_ASSIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEGMENT_ASSIGN_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
    case SEGMENT_ASSIGN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const quarterlyReviewReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
  switch (action.type) {
    case QUARTERLY_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case QUARTERLY_REVIEW_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
      };
      case QUARTERLY_REVIEW_RESET:
      // alert('action')
      return {
        ...state,
        loading: true,
        data: [],
        totalRows: 0,
        msg: null,
      };
    case QUARTERLY_REVIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const quarterlySegmentReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null, currentType:null }, action) => {
  // console.log('currentType >> ', action)
  switch (action.type) {
    case QUARTERLY_SEGMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case QUARTERLY_SEGMENT_SUCCESS:
      // alert('action')
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalRows: action.payload?.Data.length,
        msg: action.payload.msg,
        currentType: action?.currentType,
      };
      case QUARTERLY_SEGMENT_RESET:
      // alert('action')
      return {
        ...state,
        loading: true,
        data: [],
        totalRows: 0,
        msg: null,
        currentType: null,
      };
    case QUARTERLY_SEGMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const mediaModelReducer = (state = { loading: true, data: { isOpen: false } }, action) => {
  switch (action.type) {
    case MEDIA_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MEDIA_MODEL_OPEN:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case MEDIA_MODEL_CLOSE:
      return {
        ...state,
        loading: false,
        data: { isOpen: false },
      };
    default:
      return state;
  }
};


// export const ipAddressReducer = (state = { loading: true, data: [], totalRows: 0, msg: null, error: null }, action) => {
//   return publicIp.v4()
// };

